import React from 'react';
import Icon, { type CustomGlyphProps } from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';

const defaultStrokeColor = token('color.text.accent.blue.bolder');

const HierarchyIconSVG = (props: CustomGlyphProps) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="5.33333"
			cy="5.33333"
			r="1.33333"
			stroke={props.stroke || defaultStrokeColor}
			strokeWidth="1.33333"
			fill="none"
		/>
		<circle
			cx="10.6667"
			cy="10.6666"
			r="1.33333"
			stroke={props.stroke || defaultStrokeColor}
			strokeWidth="1.33333"
			fill="none"
		/>
		<path
			d="M5.33337 6.66669V9.33335C5.33337 10.0697 5.93033 10.6667 6.66671 10.6667H9.33337"
			stroke={props.stroke || defaultStrokeColor}
			strokeWidth="1.33333"
			fill="none"
		/>
	</svg>
);

type Props = {
	size: 'small' | 'medium' | 'large' | 'xlarge';
	label: string;
	stroke?: string;
};

const HierarchyIcon = (props: Props) => (
	<Icon
		glyph={(customGlyphProps: CustomGlyphProps) => (
			<HierarchyIconSVG {...customGlyphProps} stroke={props.stroke} />
		)}
		size={props.size}
		label={props.label}
	/>
);

export default HierarchyIcon;
